module.exports = __webpack_public_path__ + "lxy-admin/img/bg-login.18c73443.jpg";